import { render, staticRenderFns } from "./ElementConfigurableScaleTableColumn.vue?vue&type=template&id=7b7ca0e2&scoped=true"
import script from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScaleTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementConfigurableScaleTableColumn.vue?vue&type=style&index=0&id=7b7ca0e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7ca0e2",
  null
  
)

export default component.exports